import * as React from 'react';

export const Coinbase = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    x='0'
    y='0'
    baseProfile='tiny'
    overflow='visible'
    version='1.2'
    viewBox='0 0 1024 1024'
    xmlSpace='preserve'
    width='80'
    height='80'
  >
    <path
      fill='#0052FF'
      d='M512 0c282.8 0 512 229.2 512 512s-229.2 512-512 512S0 794.8 0 512 229.2 0 512 0z'
    ></path>
    <path
      fill='#FFF'
      d='M512.1 692c-99.4 0-180-80.5-180-180s80.6-180 180-180c89.1 0 163.1 65 177.3 150h181.3c-15.3-184.8-170-330-358.7-330-198.8 0-360 161.2-360 360s161.2 360 360 360c188.7 0 343.4-145.2 358.7-330H689.3c-14.3 85-88.1 150-177.2 150z'
    ></path>
  </svg>
);

export const Logo = () => (
  <svg
    width='60'
    height='60'
    viewBox='0 0 150 150'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      cx='75'
      cy='75'
      r='57.5'
      stroke='url(#paint0_linear_1210_876)'
      strokeWidth='35'
    />
    <defs>
      <linearGradient
        id='paint0_linear_1210_876'
        x1='23.5'
        y1='9'
        x2='93.5'
        y2='150'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E41F66' />
        <stop offset='1' stopColor='#1DB3F9' stopOpacity='0.63' />
      </linearGradient>
    </defs>
  </svg>
);


export const WalletConnect = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      baseProfile="basic"
      version="1.1"
      viewBox="0 0 387.6 237.6"
      xmlSpace="preserve"
      width='80'
      height='80'
    >
      <path
        fill="#3B99FC"
        d="M79.4 46.4c63.2-61.9 165.7-61.9 228.9 0l7.6 7.4c3.2 3.1 3.2 8.1 0 11.2l-26 25.5c-1.6 1.5-4.1 1.5-5.7 0l-10.5-10.3C229.6 37 158.1 37 114 80.2l-11.2 11c-1.6 1.5-4.1 1.5-5.7 0L71 65.8c-3.2-3.1-3.2-8.1 0-11.2l8.4-8.2zm282.7 52.7l23.2 22.7c3.2 3.1 3.2 8.1 0 11.2L280.8 235.3c-3.2 3.1-8.3 3.1-11.4 0l-74.1-72.6c-.8-.8-2.1-.8-2.9 0l-74.1 72.6c-3.2 3.1-8.3 3.1-11.4 0L2.4 133c-3.2-3.1-3.2-8.1 0-11.2l23.2-22.7c3.2-3.1 8.3-3.1 11.4 0l74.1 72.6c.8.8 2.1.8 2.9 0l74.1-72.6c3.2-3.1 8.3-3.1 11.4 0l74.1 72.6c.8.8 2.1.8 2.9 0l74.1-72.6c3.2-3.1 8.3-3.1 11.5 0z"
      ></path>
    </svg>
  );

  export const MetaMask = () => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    baseProfile="basic"
    version="1.1"
    viewBox="0 0 33.9 31.3"
    xmlSpace="preserve"
  >
    <path
      fill="#E17726"
      stroke="#E17726"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.25"
      d="M32.1.1L18.9 9.8l2.4-5.7 10.8-4z"
    ></path>
    <path
      fill="#E27625"
      stroke="#E27625"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.25"
      d="M1.8.1l13 9.8-2.3-5.8L1.8.1zM27.4 22.7L23.9 28l7.5 2.1 2.1-7.3-6.1-.1zM.4 22.8l2.1 7.3L10 28l-3.5-5.3-6.1.1z"
    ></path>
    <path
      fill="#E27625"
      stroke="#E27625"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.25"
      d="M9.6 13.6l-2.1 3.1 7.4.3-.2-8-5.1 4.6zM24.3 13.6L19.1 9l-.2 8.1 7.4-.3-2-3.2zM10 28l4.5-2.2-3.9-3L10 28zM19.4 25.8l4.5 2.2-.6-5.2-3.9 3z"
    ></path>
    <path
      fill="#D5BFB2"
      stroke="#D5BFB2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.25"
      d="M23.9 28l-4.5-2.2.4 2.9v1.2l4.1-1.9zM10 28l4.2 2v-1.2l.4-2.9L10 28z"
    ></path>
    <path
      fill="#233447"
      stroke="#233447"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.25"
      d="M14.2 20.9l-3.7-1.1 2.6-1.2 1.1 2.3zM19.6 20.9l1.1-2.3 2.6 1.2-3.7 1.1z"
    ></path>
    <path
      fill="#CC6228"
      stroke="#CC6228"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.25"
      d="M10 28l.6-5.3-4.1.1L10 28zM23.2 22.7l.6 5.3 3.5-5.2-4.1-.1zM26.4 16.8l-7.4.3.7 3.8 1.1-2.3 2.6 1.2 3-3zM10.5 19.8l2.6-1.2 1.1 2.3.7-3.8-7.4-.3 3 3z"
    ></path>
    <path
      fill="#E27525"
      stroke="#E27525"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.25"
      d="M7.5 16.8l3.1 6.1-.1-3-3-3.1zM23.4 19.8l-.1 3 3.1-6.1-3 3.1zM14.9 17.1l-.7 3.8.9 4.5.2-5.9-.4-2.4zM18.9 17.1l-.4 2.4.2 5.9.9-4.5-.7-3.8z"
    ></path>
    <path
      fill="#F5841F"
      stroke="#F5841F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.25"
      d="M19.6 20.9l-.9 4.5.6.4 3.9-3 .1-3-3.7 1.1zM10.5 19.8l.1 3 3.9 3 .6-.4-.9-4.5-3.7-1.1z"
    ></path>
    <path
      fill="#C0AC9D"
      stroke="#C0AC9D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.25"
      d="M19.7 30v-1.2l-.3-.3h-5l-.3.3V30L10 28l1.5 1.2 2.9 2h5.1l3-2 1.4-1.2-4.2 2z"
    ></path>
    <path
      fill="#161616"
      stroke="#161616"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.25"
      d="M19.4 25.8l-.6-.4h-3.7l-.6.4-.4 2.9.3-.3h5l.3.3-.3-2.9z"
    ></path>
    <path
      fill="#763E1A"
      stroke="#763E1A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.25"
      d="M32.6 10.5l1.1-5.4-1.7-5-12.6 9.4 4.9 4.1 6.9 2 1.5-1.8-.7-.4 1.1-1-.8-.6 1.1-.8-.8-.5zM.1 5.1l1.1 5.4-.7.5 1.1.8-.8.6 1.1 1-.7.5 1.5 1.8 6.9-2 4.9-4.1L1.8.1l-1.7 5z"
    ></path>
    <path
      fill="#F5841F"
      stroke="#F5841F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.25"
      d="M31.2 15.6l-6.9-2 2.1 3.1-3.1 6.1 4.1-.1h6.1l-2.3-7.1zM9.6 13.6l-6.9 2-2.3 7.1h6.1l4.1.1-3.1-6.1 2.1-3.1zM18.9 17.1l.4-7.6 2-5.4h-8.9l2 5.4.4 7.6.2 2.4v5.9h3.7v-5.9l.2-2.4z"
    ></path>
  </svg>
  )